import React from 'react';

const NoCardDetailsFound = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/no-card-details-found.png"} width="300" />
    </div>;
}

export default NoCardDetailsFound;